
const u = navigator.userAgent;
export default{
    // str = String(str);
    // var app = navigator.appVersion;
    isAndroid : u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,//android终端或者uc浏览器   
    isiOS : !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端 
}